import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { ButtonIcon } from '../ui/button-icon';
import { Paragraph } from '../ui/paragraph';
import { GoArrowUpRight } from 'react-icons/go';
import { Button } from '../ui/button';

export function Stores({ stores, className }: { stores: TDynamicData[]; className?: string }) {
  const store = stores?.[0];
  const fields = store?.fields ?? [];

  if (!store) return null;

  return (
    <section className={cn('custom-section', className)}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-4 md:flex-row md:items-stretch md:justify-between lg:gap-6',
        )}
      >
        <div className="relative h-[400px] w-full max-w-[925px] overflow-hidden rounded-[12px] p-6 sm:h-[430px] sm:p-8 lg:h-[500px] lg:p-12">
          <div className="relative z-10 flex h-full w-full flex-col items-start justify-between">
            <Heading
              title={store.name}
              tag="p"
              styleAs="h5"
              className={{ title: 'text-secondary' }}
            />
            <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-6 lg:gap-8">
              <Heading title={fields[0]?.value} color="white" />
              <div className="flex w-full flex-col items-start justify-start gap-4">
                {!!fields[1]?.value && (
                  <div className="flex w-full items-start justify-start gap-2.5 sm:items-center">
                    <ButtonIcon alt="Adresa" url="/images/icons/store-location.svg" />
                    <Paragraph color="white" size="lg">
                      {fields[1]?.value}
                    </Paragraph>
                  </div>
                )}
                {!!fields[2]?.value && (
                  <div className="flex w-full items-start justify-start gap-2.5 sm:items-center">
                    <ButtonIcon alt="Otváracia doba" url="/images/icons/store-time.svg" />
                    <Paragraph color="white" size="lg">
                      {fields[2]?.value}
                    </Paragraph>
                  </div>
                )}
              </div>
              {!!fields[3]?.value && (
                <Button asChild>
                  <Link prefetch={false} href={fields[3]?.value}>
                    Navigovať <GoArrowUpRight size={20} />
                  </Link>
                </Button>
              )}
            </div>
          </div>
          <div className="ea-store__image-background absolute inset-0 z-[1] h-full w-full" />
          <Image
            src={store.image?.url ?? ''}
            alt={resolveImageAlt(store?.image, store?.name)}
            width={0}
            height={0}
            className="absolute inset-0 z-0 h-full w-full object-cover object-center"
            sizes="100vw"
          />
        </div>
        <iframe
          src={`https://www.google.com/maps?q=${encodeURIComponent(fields[1]?.value ?? '')}&output=embed`}
          title="Mapa obchodu"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="h-[200px] w-full overflow-hidden rounded-[12px] border-0 object-cover object-center sm:h-[350px] md:h-auto md:max-w-[451px]"
        />
      </div>
    </section>
  );
}
